import { defineStore } from "pinia";
import http from "@/axios-config";

// This store is used for general menu information, e.g. total vegan dishes
export const useMenuInfoStore = defineStore("menu-info", {
    state: () => ({
        dishes: 0,
        halal: 0,
        kosher: 0,
        vegetarian: 0,
        vegan: 0,
        glutenFree: 0,
        spicy: 0,
        sites: [],
        menus: 0,
        tevalis_updated: 0,
        using_tevalis: true,
    }),
    actions: {
        async getMenuInfo() {
            await http
                .get("/api/dashboard")
                .then((response) => {
                    this.sites = response.data.sites;
                    this.dishes = response.data.totalDishes;
                    this.halal = response.data.totalHalalDishes;
                    this.kosher = response.data.totalKosherDishes;
                    this.vegetarian = response.data.totalVegetarianDishes;
                    this.vegan = response.data.totalVeganDishes;
                    this.glutenFree = response.data.totalGlutenFreeDishes;
                    this.spicy = response.data.totalSpicyDishes;
                    this.menus = response.data.menus;
                    this.tevalis_updated = response.data.tevalis_updated;
                    this.using_tevalis = response.data.using_tevalis;
                })
                .catch(function (error) {
                    console.error(error);
                });
        },

        async getSites() {
            const response = await http.get("/api/sites/index");
            this.sites = response.data;
        },
    },
    // optional getters
    getters: {},
});
